import {
  type GetLoginInfoResponse,
  getLoginInfo,
} from '@otter-ai/recall-client';
import type { AdditionalQueryOptions } from '../shared/utils/queryCreators';

type LoginInfoQueryKey = ['loginInfo'];

type AdditionalLoginInfoQueryOptions = AdditionalQueryOptions<
  GetLoginInfoResponse,
  LoginInfoQueryKey
>;

export type LoginInfoQuery = {
  readonly queryKey: LoginInfoQueryKey;
  readonly queryFn: () => Promise<GetLoginInfoResponse>;
} & AdditionalLoginInfoQueryOptions;

/**
 * Create a query to fetch the user's login info
 *
 * @example
 * ```tsx
 * const { data: loginInfo } = useQuery(loginInfoQueryCreator());
 * ```
 */

export function loginInfoQueryCreator(
  additionalOptions: AdditionalLoginInfoQueryOptions = {},
): LoginInfoQuery {
  return {
    ...additionalOptions,
    queryKey: ['loginInfo'],
    queryFn: async () => {
      const response = await getLoginInfo({ throwOnError: true });
      return response.data;
    },
  };
}
